export enum AdOrderItemDeclineType {
  /** Неподходящий контент */
  INAPPROPRIATE_CONTENT = 'inappropriate_content',

  /** Реклама конкурента */
  COMPETITOR_AD = 'competitor_ad',

  /** Нарушение политики канала */
  VIOLATES_POLICY = 'violates_policy',

  /** Недостаточный бюджет */
  LOW_BUDGET = 'low_budget',

  /** Конфликт расписания */
  SCHEDULE_CONFLICT = 'schedule_conflict',

  /** Неполная информация */
  INCOMPLETE_INFORMATION = 'incomplete_information',

  /** Неподходящая аудитория */
  UNSUITABLE_AUDIENCE = 'unsuitable_audience',

  /** Технические проблемы */
  TECHNICAL_ISSUES = 'technical_issues',

  /** Нерелевантный контент */
  IRRELEVANT_CONTENT = 'irrelevant_content',

  /** Слишком частое размещение */
  HIGH_FREQUENCY = 'high_frequency',

  /** Другое */
  OTHER = 'other',
}
